import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import StickyBox from "react-sticky-box";
import Media from 'react-media';

import classes from './MarksListing.module.scss';

import { loadFilters, loadMarks, setCurrentPage } from '../../../redux/marks/actions';

import MarksToolbar from '../MarksToolbar/MarksToolbar'
import MarksFilters from '../MarksFilters/MarksFilters'
import MarksList from '../MarksList/MarksList'
import MarksCards from '../MarksCards/MarksCards'
import MarksPager from '../MarksPager/MarksPager'

class MarksListing extends Component {

    componentDidMount(){
      this.props.loadMarks();
    }

    componentDidUpdate(prevProps){
      if(this.props.currentpage != prevProps.currentpage || this.props.selectedfilters != prevProps.selectedfilters  || this.props.length != prevProps.length  || this.props.type != prevProps.type){
        this.props.loadMarks();
      }
    }
    handlePageChange = (page)=>{
      this.props.setCurrentPage(page.selected);
    }
    render() {
        return(
            <Media query={{ maxWidth: 751 }}>
            {matches => (
              <Fragment>
                {matches ? <Fragment>
            <MarksToolbar />
            <div className={classes.Container}>
              <MarksFilters  />
              <div className={classes.Listing}>{ this.props.displaytype=="list" ? <MarksList /> : <MarksCards /> } <MarksPager /></div>
            </div>
            </Fragment>
              : <Fragment>
              <StickyBox style={{zIndex:300000}} offsetTop={0} offsetBottom={20}><MarksToolbar /></StickyBox>
              <div className={classes.Container}>
                <StickyBox className={classes.Filters} offsetTop={52} offsetBottom={0}><MarksFilters  /></StickyBox>
                <div className={classes.Listing}>{ this.props.displaytype=="list" ? <MarksList /> : <MarksCards /> } <MarksPager /></div>
              </div>
              </Fragment> }
              </Fragment>
            )}
          </Media>
            
        );
    }
}

const mapStateToProps = (state)=>{
  return {
    filters: state.marks.filters,
    selectedfilters: state.marks.selectedfilters,
    currentpage:state.marks.currentpage,
    totalpage:state.marks.totalpage,
    length: state.marks.length,
    displaytype: state.marks.displaytype,
    type: state.marks.type
  }
};


export default connect(mapStateToProps, {loadFilters,loadMarks})(MarksListing);
